import { KNOWN_FLAG_KEYS, isKnownFlagKey } from './known-flag-keys';

export type FlagKeyClassification = {
  known: readonly AppConfigFeatureFlagKey[];
  unknown: readonly string[];
};

/**
 * Walks the full AppConfig JSON and returns every distinct flag key encountered
 * across `allAdvisors` and every `advisors[id]` override, split into known keys
 * (declared in `AppConfigFeatureFlagKey`) and unknown keys (legacy or stale).
 */
export function classifyFlagKeys(config: AppConfigSchema): FlagKeyClassification {
  const seen = new Set<string>();

  for (const key of Object.keys(config.allAdvisors ?? {})) {
    seen.add(key);
  }
  for (const overrides of Object.values(config.advisors ?? {})) {
    for (const key of Object.keys(overrides ?? {})) {
      seen.add(key);
    }
  }

  const known = new Set<AppConfigFeatureFlagKey>();
  const unknown: string[] = [];

  for (const key of seen) {
    if (isKnownFlagKey(key)) {
      known.add(key);
    } else {
      unknown.push(key);
    }
  }

  // Union of keys that appeared in the JSON with all declared keys — the UI
  // should always show every declared flag, even if it has no value anywhere yet.
  for (const key of KNOWN_FLAG_KEYS) {
    known.add(key);
  }

  return {
    known: [...known].sort() as AppConfigFeatureFlagKey[],
    unknown: unknown.sort(),
  };
}
